<template>
  <router-view/>
  <ToastContainer />
</template>

<script>
import ToastContainer from './components/common/ToastContainer.vue';

export default {
  components: {
    ToastContainer
  }
}
</script>

<style scoped>
</style>
